import type { SdkConfig } from '../core/types';
import type { Api } from '../core/api';
import { throttle } from '../core/utils';
import { redactUrl } from '../core/redact';

const THRESHOLDS = [25, 50, 75, 100] as const;

export function installScroll(config: SdkConfig, emblue: Api): void {
	if (!config.autoTrack.scroll) return;
	if (typeof window === 'undefined') return;

	let fired: Record<number, true> = {};
	let lastUrl = location.href;

	const reset = () => {
		fired = {};
		lastUrl = location.href;
	};

	const tick = throttle(() => {
		if (lastUrl !== location.href) reset();
		const doc = document.documentElement;
		const body = document.body;
		const scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
		const height = Math.max(doc.scrollHeight, body.scrollHeight) - window.innerHeight;
		if (height <= 0) return;
		const pct = Math.floor((scrollTop / height) * 100);
		for (const t of THRESHOLDS) {
			if (pct >= t && !fired[t]) {
				fired[t] = true;
				emblue.track('scroll_depth', {
					threshold: t,
					page_url: redactUrl(location.href),
				});
			}
		}
	}, 200);

	window.addEventListener('scroll', tick, { passive: true });
	window.addEventListener('popstate', reset);
}
